export type Dica = {
  titulo: string;
  texto: string;
  passos?: string[];
  proximo?: { rotulo: string; para: string };
};

export const DICAS: Record<string, Dica> = {
  'criar.portas': {
    titulo: 'Por onde começar',
    texto:
      'Escolha o que mais parece com o seu evento. Dá para mudar tudo depois, nada aqui é definitivo.',
    passos: [
      'Acampamento, retiro, curso ou encontro com ficha de inscrição → "Abrir inscrições".',
      'Luau, show, festa com entrada paga → "Vender ingresso".',
      'Ação entre amigos para arrecadar → "Fazer uma ação entre amigos".',
      'Só quer que as pessoas saibam do evento → "Divulgar um evento".',
      'Quermesse ou festa com barracas: crie por "Vender ingresso" ou "Divulgar um evento" e depois ligue "Fichas e barracas" em Editar evento.',
    ],
  },
  'criar.evento': {
    titulo: 'Sobre o evento',
    texto:
      'Nome, quando e onde. É o que as pessoas veem primeiro. O resto a gente pergunta depois.',
    passos: [
      'Nome: o que o pessoal vai falar no WhatsApp ("Acampamento de Carnaval 2027").',
      'Data e hora de início. Se o evento dura mais de um dia, informe também o fim; senão ele aparece como 3 horas.',
      'Cidade e estado: é assim que ele aparece na agenda.',
      'Capa: uma imagem na horizontal (1200 × 675 funciona bem), até 5 MB, em JPG ou PNG. Foto do iPhone em HEIC não é aceita: escolha "Mais compatível" na câmera ou mande pelo WhatsApp e salve.',
      'Este passo salva sozinho enquanto você digita.',
    ],
  },
  'criar.inscricoes': {
    titulo: 'Tipos de inscrição',
    texto:
      'Cada jeito diferente de participar é um tipo: campista, equipe, casal, criança. Cada tipo tem seu valor e suas vagas.',
    passos: [
      'Comece com um ou dois tipos. Dá para criar mais depois.',
      'Toque em "R$" para cobrar. "Gratuito" significa que ninguém paga nada.',
      'Vagas: deixe em branco se não tiver limite.',
      'Em "Mais opções": quando as inscrições abrem e fecham, e se o tipo é só para quem tem o link (bom para equipe).',
    ],
    proximo: { rotulo: 'Ver exemplo de acampamento', para: '#exemplo' },
  },
  'criar.pagamento': {
    titulo: 'Como se paga',
    texto:
      'Duas perguntas: como a pessoa paga, e para onde vai o dinheiro. Responda as duas antes de publicar.',
    passos: [
      'Pix pelo app: a pessoa paga na hora da inscrição e recebe o comprovante.',
      'Ação entre amigos: cada inscrito vende números e o que vende abate a inscrição dele.',
      'Direto com a organização: você combina fora do app e marca como pago no painel.',
      'Para onde vai: "conta do organizador" (o dinheiro cai direto na conta Mercado Pago da paróquia — alguém com o login dela conecta pelo link) ou "conta do Se Liga e repassamos por Pix" (informe a chave Pix).',
      'Se algum tipo tem preço, não deixe em "Não se paga".',
    ],
  },
  'criar.sorteio': {
    titulo: 'Ação entre amigos',
    texto:
      'Números vendidos pelos próprios inscritos, por um link de cada um. O comprador paga por Pix e recebe o número na hora.',
    passos: [
      'Prêmio e valor do número. Números por talão é quanto cada vendedor recebe para vender.',
      'Total de números: com 300 inscritos e 20 por talão, 6.000 números.',
      'Data do resultado: aparece para o comprador.',
      'A lei pede que uma entidade responda pela ação (nome e CNPJ) e, para ação entre amigos com prêmio em dinheiro ou de valor alto, uma autorização. Sem isso o evento publica, mas a venda dos números fica esperando.',
    ],
  },
  'criar.ficha': {
    titulo: 'Ficha de inscrição',
    texto:
      'As perguntas que a coordenação precisa: alergia, remédio, contato de emergência, camiseta. Nome, CPF, nascimento e telefone já são pedidos, não repita.',
    passos: [
      'Toque em "Usar perguntas comuns de acampamento" para começar com as principais.',
      'Cada tipo de inscrição tem a sua ficha (a de equipe pode ser diferente da de campista).',
      'Pergunta obrigatória trava a inscrição até ser respondida: use com moderação.',
      'As perguntas só são gravadas quando você toca em "Continuar".',
    ],
  },
  'criar.datas': {
    titulo: 'Encontros e formações',
    texto:
      'Os dias em que a equipe se reúne antes do evento. Servem para a chamada por QR code e a frequência de cada servo.',
    passos: [
      'Pode pular agora e criar depois em Editar evento → Encontros.',
      'Cada encontro vira uma chamada: quem chega mostra o QR ou a direção marca a presença.',
      'A frequência aparece no painel, em Equipe › Formações e presenças.',
    ],
  },
  'criar.publicar': {
    titulo: 'Publicar',
    texto:
      'Publicar coloca o evento na agenda e libera o link de inscrição. Você continua podendo editar quase tudo.',
    passos: [
      'Confira: capa, data, local, tipos com valor, como se paga e para onde vai o dinheiro.',
      'Depois de publicar, o link do evento não muda mais. O nome e o resto, sim.',
      'Convide quem vai ajudar a administrar em "Quem mais administra". Caixa, barraca e portaria você chama depois, por link, em Dia do evento › Quem está servindo.',
    ],
  },
  'criar.ingresso': {
    titulo: 'Vender ingresso',
    texto:
      'Ingresso é para evento de entrada: luau, show, festa. A pessoa compra pelo celular, paga por Pix e recebe o QR code, sem precisar criar conta.',
    passos: [
      'Nome, data, local e capa.',
      'Lotes: "Primeiro lote R$ 20 · Segundo lote R$ 25". Se não quiser lotes, crie um só.',
      'Chave Pix para o repasse: é para onde o Se Liga manda o dinheiro dos ingressos.',
      'Na portaria, o QR do ingresso é lido pelo celular. Você chama a portaria por link em Dia do evento › Quem está servindo.',
    ],
  },
  'meus-eventos': {
    titulo: 'Meus eventos',
    texto:
      'Tudo que você organiza ou ajuda a administrar. Toque num evento para abrir o painel dele.',
    passos: [
      '"Continuar criando" retoma um rascunho.',
      'Rascunho não aparece para ninguém; publicado aparece na agenda.',
      'Para criar outro: "Novo evento", no menu do seu nome.',
    ],
    proximo: { rotulo: 'Criar um evento', para: '/criar' },
  },
  'painel.inicio': {
    titulo: 'Início',
    texto:
      'O resumo do seu evento e o que precisa de você agora. Se algo está faltando, aparece aqui com um botão.',
  },
  'painel.inicio.vazio': {
    titulo: 'Seu evento ainda não tem inscritos',
    texto:
      'Divulgue o link para começar a receber inscrições. Quem se inscrever aparece em Pessoas.',
    proximo: { rotulo: 'Ver o link de divulgação', para: '/gerenciar/:id?aba=inicio&divulgar=1' },
  },
  'painel.pessoas': {
    titulo: 'Pessoas',
    texto:
      'Quem se inscreveu ou comprou, com a situação de cada um. Toque na pessoa para ver a ficha, registrar pagamento ou confirmar.',
    passos: [
      'Filtros: por tipo, por situação (esperando Pix, confirmada, cancelada) e pelas respostas da ficha.',
      '"Baixar" gera a planilha com todo mundo.',
      'Registrar pagamento: para quem pagou fora do app (dinheiro, Pix direto para a paróquia).',
    ],
  },
  'painel.pessoas.vazio': {
    titulo: 'Ainda não há inscrições',
    texto:
      'Assim que alguém se inscrever pelo link do evento, aparece aqui. Mande o link no WhatsApp da comunidade.',
    proximo: { rotulo: 'Ver o link de divulgação', para: '/gerenciar/:id?aba=inicio&divulgar=1' },
  },
  'painel.equipe': {
    titulo: 'Quem está servindo',
    texto:
      'Quem trabalha no dia do evento: caixa, barraca e portaria. Você chama cada pessoa por um link no WhatsApp e ela aceita pelo celular.',
    passos: [
      '"Chamar pessoa" gera um link para uma função. Mande pelo WhatsApp.',
      'A pessoa toca no link, entra com a conta dela e está dentro.',
      'Em "Vendas" você vê, ao vivo, quem vendeu quanto, em dinheiro, Pix ou cartão.',
      'Caixa e barraca só aparecem para chamar depois de criados em Dia do evento › Barracas e produtos.',
    ],
  },
  'painel.equipe.vazio': {
    titulo: 'Ninguém na equipe do dia ainda',
    texto:
      'Chame a primeira pessoa: escolha a função (caixa, barraca ou portaria), gere o link e mande no WhatsApp dela.',
  },
  'painel.equipes': {
    titulo: 'Equipes de serviço',
    texto:
      'A montagem das equipes do acampamento (cozinha, liturgia, música…). O sistema sugere pessoas pelos talentos e pelo histórico de cada servo.',
    passos: [
      '"Criar as equipes do acampamento" cria a lista padrão; ajuste as vagas de cada uma.',
      'Toque numa equipe e depois em "Sugerir" para ver quem combina.',
      'Quem faltou às formações e não justificou aparece em Equipe › Formações e presenças, e pode ser tirado da montagem.',
    ],
  },
  'painel.equipes.vazio': {
    titulo: 'Comece criando as equipes',
    texto:
      'O botão abaixo cria as equipes mais comuns de um acampamento, com vagas sugeridas. Depois você renomeia, ajusta as vagas e começa a alocar.',
  },
  'painel.encontros': {
    titulo: 'Formações e presenças',
    texto:
      'As formações e reuniões antes do evento. Cada uma tem uma chamada por QR code e a frequência de cada servo fica registrada.',
    passos: [
      'Crie os encontros em Editar evento → Encontros (data, hora e local).',
      'No dia: "Gerar QR" e mostre na tela ou projete. Quem chega escaneia com o celular e aparece na lista.',
      'Quem não conseguiu escanear: marque à mão.',
      'Depois da formação, "Fechar conferência" congela a lista. Só então dá para justificar faltas.',
    ],
  },
  'painel.encontros.vazio': {
    titulo: 'Nenhum encontro criado ainda',
    texto:
      'Crie os encontros (formações, reuniões) para fazer a chamada por QR code e acompanhar a frequência.',
    proximo: { rotulo: 'Criar encontros', para: '/evento/:id/editar' },
  },
  'painel.loja': {
    titulo: 'Loja: fichas e barracas',
    texto:
      'Para quermesse, festa e luau com venda de comida e bebida. O público compra fichas online ou no caixa, e a barraca lê o QR da ficha para entregar.',
    passos: [
      '1 · Crie as barracas (Bebidas, Doces…).',
      '2 · Cadastre os produtos de cada barraca, com preço e, se quiser, estoque e custo.',
      '3 · Crie o caixa. Se tiver maquininha do Mercado Pago, ligue-a ao caixa para cobrar cartão e imprimir as fichas.',
      '4 · Ligue as vendas online, se quiser vender fichas pelo site antes do dia.',
      '5 · Chame caixa e barraca em Dia do evento › Quem está servindo.',
    ],
  },
  'painel.dia': {
    titulo: 'Dia do evento',
    texto:
      'Tudo o que acontece no dia, num lugar só: caixa, vendas, barracas, quem está servindo e portaria.',
    passos: [
      'Abrir o caixa: vende ficha, cobra cartão e imprime.',
      'Vendas de hoje: quanto entrou, por meio de pagamento e por barraca.',
      'Barracas e produtos: cria barraca, cardápio e preço.',
      'Quem está servindo: chama a pessoa por link no WhatsApp.',
      'Portaria: lê o QR do ingresso na entrada.',
    ],
  },
  'painel.loja.primeira': {
    titulo: 'Como a loja funciona',
    texto:
      'Primeiro as barracas, depois os produtos, depois o caixa. No dia, o caixa vende e imprime a ficha; a barraca lê o QR e entrega. Você acompanha tudo em Dia do evento › Vendas de hoje.',
  },
  'painel.financeiro': {
    titulo: 'Financeiro',
    texto:
      'Quanto entrou, por onde entrou, quanto é seu e quanto fica de taxa. Lance as despesas para ver o resultado do evento.',
    passos: [
      'Entradas: inscrições e ingressos pelo app, fichas, caixa e ação entre amigos.',
      'Taxas: a do Se Liga e a do Mercado Pago aparecem separadas.',
      '"A repassar": o que ainda vai cair na sua conta, quando o dinheiro passa pelo Se Liga.',
      'Despesas: lance chácara, alimentação, som… O lucro aparece embaixo.',
    ],
  },
  'painel.financeiro.primeira': {
    titulo: 'De onde vêm estes números',
    texto:
      'Tudo aqui vem dos pagamentos confirmados. O que a pessoa ainda não pagou não entra. Se o valor parecer estranho, confira em Pessoas quem está "esperando Pix".',
  },
  'painel.sorteio': {
    titulo: 'Ação entre amigos',
    texto:
      'A ação entre amigos deste evento: prêmios, talões, quem vendeu quanto e os números pagos.',
    passos: [
      'Prêmios com foto aparecem na página pública da ação.',
      '"Repartir talões" dá a cada inscrito o link dele para vender.',
      'O ranking mostra os vendedores. A cartela pode ser impressa.',
      'No dia do resultado, registre o número apurado e o ganhador.',
    ],
  },
  'painel.portaria': {
    titulo: 'Portaria',
    texto:
      'Quem entrou, quem falta e a hora da última entrada. A leitura dos ingressos é feita no celular do porteiro.',
    passos: [
      'Chame o porteiro por link em Dia do evento › Quem está servindo (função Portaria).',
      'Ele abre o link, entra com a conta dele e o leitor aparece.',
      'Sem sinal? O leitor avisa e não libera ninguém por engano. Use "Digitar código" se o QR não ler.',
    ],
  },
  'painel.portaria.primeira': {
    titulo: 'Antes do dia',
    texto:
      'Teste a portaria com um ingresso seu: abra o leitor, escaneie e veja a entrada aparecer aqui. Chame os porteiros por link com antecedência.',
  },
  'painel.ajustes': {
    titulo: 'Mais',
    texto:
      'Quem mais administra o evento, os recursos ligados (equipes, encontros, loja) e o histórico do que foi feito.',
    passos: [
      '"Quem está na direção" dá acesso total ao painel. Para caixa, barraca e portaria use Dia do evento › Quem está servindo.',
      'Ligue só os recursos que vai usar: as abas aparecem conforme você liga.',
      'Precisa encerrar ou tirar do ar? Por enquanto fale com o Se Liga pelo WhatsApp (14) 99640-2835.',
    ],
  },
  'caixa.sem-evento': {
    titulo: 'Você ainda não é caixa de nenhum evento',
    texto:
      'Quem organiza o evento chama o caixa por um link, em Dia do evento › Quem está servindo. Peça o link para a direção e toque nele com esta conta.',
    proximo: { rotulo: 'Voltar ao início', para: '/' },
  },
  caixa: {
    titulo: 'Como vender no caixa',
    texto:
      'Escolha os produtos, escolha como a pessoa paga e entregue as fichas. O sistema soma tudo e guarda cada venda no seu nome.',
    passos: [
      'Toque nos produtos para somar. Toque de novo para aumentar a quantidade.',
      'Dinheiro: digite quanto a pessoa entregou; o troco aparece na tela.',
      'Cartão ou Pix: a maquininha cobra e já imprime as fichas.',
      'Errou? Em "Vendas recentes" dá para desfazer, com o motivo.',
      'No fim do turno: "Fechar caixa" mostra quanto você vendeu em dinheiro, Pix e cartão.',
    ],
  },
  'caixa.fechamento': {
    titulo: 'Fechar o caixa',
    texto:
      'Confira o dinheiro da gaveta com o total em dinheiro desta tela. Cartão e Pix já estão registrados.',
    passos: [
      'Conte o dinheiro e compare com "Dinheiro".',
      'Diferença? Veja em "Vendas recentes" se alguma venda ficou errada.',
      'Imprima ou mostre esta tela para a direção e entregue o dinheiro.',
    ],
  },
  barraca: {
    titulo: 'Como entregar na barraca',
    texto:
      'A pessoa mostra o QR da ficha (impressa ou no celular). Você lê, vê o que ela pode retirar e confirma a entrega.',
    passos: [
      'Toque em "Ler ficha" e aponte a câmera para o QR.',
      'Aparece o que ela pode retirar desta barraca. Confirme a entrega.',
      'Ficha de papel sem QR legível? Use "Digitar número".',
      'Entregou errado? Em "Entregas recentes" dá para desfazer.',
    ],
  },
  portaria: {
    titulo: 'Como liberar a entrada',
    texto:
      'Aponte a câmera para o QR do ingresso. Verde: pode entrar. Vermelho: não entra, e o motivo aparece.',
    passos: [
      'Verde com o nome da pessoa: libere a entrada.',
      'Vermelho "já entrou": o ingresso já foi usado. Chame a direção se houver dúvida.',
      'Sem sinal: o leitor avisa e não libera ninguém por engano. Espere o sinal voltar.',
      'QR não lê? "Digitar código" com os 8 primeiros caracteres que aparecem embaixo do QR no celular da pessoa.',
      'Os números no topo mostram quantos já entraram e quantos faltam.',
    ],
  },
  'meu-talao': {
    titulo: 'Como vender seus números',
    texto:
      'Cada venda é feita pelo seu talão: o comprador paga por Pix no celular dele e o número fica dele na hora.',
    passos: [
      '"Nova venda" → escolha os números (ou deixe o sistema escolher).',
      'Nome e WhatsApp do comprador → aparece o Pix. Ele paga pelo celular dele.',
      'Pagou: o número fica vendido e aparece na sua lista.',
      'Mande também o link do seu talão no WhatsApp: quem compra por ele conta como venda sua.',
      'No acampamento, o que você vende abate a sua inscrição.',
    ],
  },
  'minhas-rifas': {
    titulo: 'Ação entre amigos',
    texto:
      'São os talões que você recebeu para vender. Toque em um para abrir o talão e vender.',
  },
  'minhas-inscricoes': {
    titulo: 'Minhas inscrições',
    texto:
      'As suas inscrições e as de quem você inscreveu (filhos, cônjuge). Toque em uma para ver a situação e o que falta.',
    passos: [
      '"Esperando Pix": o pagamento ainda não caiu. Toque para pagar.',
      '"Confirmada": está tudo certo.',
      'Pagou fora do app? Aparece quando a direção registrar.',
    ],
  },
  'minha-inscricao': {
    titulo: 'Sua inscrição',
    texto:
      'Aqui você vê a situação, quanto falta pagar e a sua ficha. Guarde este link: é por ele que você acompanha tudo.',
  },
  'meus-ingressos': {
    titulo: 'Meus ingressos',
    texto:
      'Cada ingresso tem um QR code. Na entrada, abra esta tela e mostre o QR para a portaria.',
    passos: [
      'Tire um print do QR antes de sair de casa, caso fique sem sinal no local.',
      'Comprou para outras pessoas? Cada uma tem o seu QR. Mande o de cada um pelo WhatsApp.',
    ],
  },
  'minhas-compras': {
    titulo: 'Minhas compras',
    texto:
      'As fichas que você comprou pelo site. Na barraca, mostre o QR da carteira e retire.',
  },
  carteira: {
    titulo: 'Carteira de fichas',
    texto:
      'Mostre este QR na barraca para retirar. Pode usar aos poucos: o que já foi retirado sai da lista.',
  },
  'meu-perfil': {
    titulo: 'Meu perfil',
    texto:
      'Seus dados preenchem as fichas de inscrição sozinhos. Mantenha o WhatsApp certo: é por ele que você recupera a senha e recebe avisos.',
    passos: [
      'Esqueceu a senha? Na tela Entrar, toque em "Esqueci minha senha" e siga as instruções pelo WhatsApp.',
      'A foto ajuda a direção a reconhecer você nas formações e na montagem das equipes.',
    ],
  },
  convites: {
    titulo: 'Convites',
    texto:
      'Quando alguém te chama para ajudar a administrar um evento, o convite aparece aqui. Aceite e o evento aparece em Meus eventos.',
  },
  presenca: {
    titulo: 'Marcar presença',
    texto:
      'Aponte a câmera para o QR que a direção está mostrando. Sua presença aparece na hora.',
    passos: [
      'Pediu para permitir a câmera? Toque em "Permitir".',
      'Não conseguiu ler? Peça para a direção marcar sua presença à mão.',
    ],
  },
  'equipe.convite': {
    titulo: 'Convite da equipe',
    texto:
      'Você foi chamado para trabalhar no evento (caixa, barraca ou portaria). Toque em aceitar com a sua conta.',
    passos: [
      'Ainda não tem conta? Crie na hora, leva um minuto.',
      'Depois de aceitar, a sua função aparece no menu do seu nome (Caixa, Minha barraca ou Portaria).',
    ],
  },
};